import React from "react";
import { PlayCircle } from "lucide-react";
import introVideo from "../../../assets/videos/intro-video.mp4";
import videoThumbnail from "../../../assets/videos/thambell.jpg";

const IntroVideoSection = () => {
  return (
    <div style={{ background: "#ffffff" }}>
      <section
        style={{
          maxWidth: "1240px",
          margin: "0 auto",
          padding: "30px 20px",
        }}
      >
        {/* Section Header */}
        <div
          style={{
            maxWidth: "760px",
            margin: "0 auto 45px",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              margin: "0",
              color: "#171717",
              fontSize: "42px",
              fontWeight: "700",
              lineHeight: "1.15",
              letterSpacing: "-1px",
            }}
          >
            Discover <span style={{ color: "#e404e4" }}>Our Iconic City</span>
          </h2>

          <p
            style={{
              margin: "18px 0 0",
              color: "#555",
              fontSize: "17px",
              lineHeight: "1.7",
              fontWeight: "500",
            }}
          >
            Sanarpar, Demra, Dhaka, Bangladesh
          </p>

          <p
            style={{
              maxWidth: "650px",
              margin: "8px auto 0",
              color: "#888",
              fontSize: "15px",
              lineHeight: "1.8",
            }}
          >
            Take a closer look at our location, surroundings, and the vision
            behind Iconic City.
          </p>
        </div>

        {/* Video Container */}
        <div
          style={{
            position: "relative",
            overflow: "hidden",
            borderRadius: "24px",
            background: "#000",
            boxShadow: "0 20px 50px rgba(0, 0, 0, 0.12)",
          }}
        >
          <video
            style={{
              display: "block",
              width: "100%",
              aspectRatio: "16 / 9",
              objectFit: "cover",
              backgroundColor: "#000",
              height: "600px",
            }}
            src={introVideo}
            poster={videoThumbnail}
            controls
            loop
            playsInline
            preload="metadata"
          >
            Your browser does not support the video tag.
          </video>

          {/* Top Gradient */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "100px",
              pointerEvents: "none",
              background:
                "linear-gradient(to bottom, rgba(0,0,0,0.35), transparent)",
            }}
          />

          {/* Video Label */}
          <div
            style={{
              position: "absolute",
              top: "20px",
              left: "20px",
              pointerEvents: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 14px",
                borderRadius: "50px",
                color: "#fff",
                fontSize: "13px",
                fontWeight: "500",
                background: "rgba(0, 0, 0, 0.38)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
              }}
            >
              <PlayCircle size={17} />
              <span>Explore Iconic City</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IntroVideoSection;
